import { useEffect, useState } from 'react';
import MinusIcon from '../Icons/MinusIcon';
import AddIcon from '../Icons/AddIcon';
import { FEATURE } from '../../../constants/emarsys/feature';
import eventClickTestDriveList from '../../../helpers/emarsys/test-drive/eventClickTestDriveList';
import { BUTTON_NAME_TEST_DRIVE_LIST } from '../../../constants/emarsys/test-drive';

export interface AccordionProps {
  title: string;
  iconTitle?: React.ReactNode;
  children: React.ReactNode;
  index?: string;
  dataIndex?: number;
  classTitle?: string;
  activeIcon?: React.ReactNode;
  inactiveIcon?: React.ReactNode;
  classNameContainer?: string;
  classNameDetails?: string;
  classNameSummary?: string;
  rightSection?: () => React.ReactNode;
  customComponent?: () => React.ReactNode;
  classTitleWrapper?: string;
  classNameChildrenWrapper?: string;
  isCMS?: boolean;
  open?: boolean;
  name?: string;
  onClick?: () => void;
  feature?: string;
  impressionData?: {
    title: string;
    category?: string;
    section: string;
    menu_cat_lvl1: string;
    menu_cat_lvl2?: string;
  };
  dataTestId?: string;
}

const Accordion = ({
  iconTitle,
  children,
  rightSection = () => <></>,
  customComponent,
  title = '',
  classTitle = '',
  index = '',
  classNameContainer = '',
  classNameDetails = 'py-[18px] lg:px-5',
  classNameSummary = 'flex justify-start items-center -my-[18px] py-[13px] md:py-[18px] text-sm text-start font-medium text-reliableBlack cursor-pointer lg:text-base',
  classTitleWrapper = 'w-full flex justify-between items-center',
  classNameChildrenWrapper = 'text-start font-normal text-reliableBlack leading-relaxed lg:leading-relaxed',
  activeIcon = <MinusIcon />,
  inactiveIcon = <AddIcon />,
  isCMS = false,
  open = false,
  name,
  feature,
  impressionData,
  onClick,
  dataTestId = '',
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const childrenClassName =
    classNameChildrenWrapper ||
    'text-start font-normal text-reliableBlack leading-relaxed lg:leading-relaxed';

  return (
    <button
      className={`block w-full border-b border-reliableBlack10 ${classNameContainer}`}
      type="button"
    >
      <details name={name} className={classNameDetails} open={isOpen}>
        <summary
          data-testid={`${dataTestId ? `${dataTestId}_${index}` : ''}`}
          className={`${classNameSummary} `}
          onClick={(e) => {
            if (isCMS) return;
            e.preventDefault();
            if (feature === FEATURE.TEST_DRIVE_LISTING_PAGE && !isOpen) {
              eventClickTestDriveList(
                impressionData?.title,
                impressionData?.category,
                impressionData?.section,
                BUTTON_NAME_TEST_DRIVE_LIST.EXPAND_BUTTON,
                impressionData?.menu_cat_lvl1,
                {
                  menu_cat_lvl2: impressionData?.menu_cat_lvl2,
                }
              );
            }
            setIsOpen((prev) => !prev);
            if (onClick && !isOpen) {
              onClick();
            }
          }}
        >
          <div className={`${classTitleWrapper}`}>
            <div id="branch-faq" className="flex items-center justify-between w-full">
              <h3 className={`${classTitle} question-${index}`}>
                {iconTitle}
                <span>{title}</span>
              </h3>
              <span className="ml-4 pointer-events-none">
                {' '}
                {isOpen ? activeIcon : inactiveIcon}
              </span>
            </div>
            {rightSection ? rightSection() : null}
          </div>
        </summary>
        <div className={`${childrenClassName}`}>
          <div className={`answer-${index}`}>
            {customComponent ? (
              customComponent()
            ) : typeof children === 'string' ? (
              <div
                className="prose max-sm:prose-li:text-sm max-w-none !text-xs lg:!text-base"
                dangerouslySetInnerHTML={{ __html: children }}
              />
            ) : (
              children
            )}
          </div>
        </div>
      </details>
    </button>
  );
};

export default Accordion;
